import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)({
  height: '100%',
  width: '100%',
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

export const MobileSlider = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '200vw',
  height: '100%',
  transition: 'transform 0.3s ease-in-out',
  transform: 'translateX(0)',

  [theme.breakpoints.down('lg')]: {
    '&.showRight': {
      transform: 'translateX(-80vw)',
    },
  },
}));

export const WebLayout = styled(Box)(({ theme }) => ({
  height: '100%',
  overflow: 'hidden',
  [theme.breakpoints.down('lg')]: {
    position: 'relative',
  },
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    justifyContent: 'center',
  },
}));

export const WebLeftPanel = styled(Box)(({ theme }) => ({
  height: '100%',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  transition: 'width 0.3s ease-in-out',
  width: '100%',

  '&.split': {
    width: '40%',
  },
  [theme.breakpoints.down('lg')]: {
    width: '100vw',
    flexShrink: 0,
  },
}));

export const WebRightPanel = styled(Box)(({ theme }) => ({
  height: '100%',
  overflow: 'auto',
  display: 'flex',
  flexDirection: 'column',
  transition: 'width 0.3s ease-in-out, opacity 0.3s ease-in-out',
  width: '0%',
  opacity: 0,

  '&.visible': {
    width: '60%',
    opacity: 1,
    [theme.breakpoints.down('lg')]: {
      width: '100vw',
      flexShrink: 0,
    },
  },
}));

export const PanelContent = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  maxWidth: theme.breakpoints.values.md,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
  margin: '0 auto',
}));

// Legacy styles kept for backward-compatibility (referenced by external
// consumers, even though FlexibleLayout itself no longer uses them).
export const LeftPanel = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  minHeight: 0,
});

export const RightPanel = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  minHeight: 0,
  width: '100%',
});

export const PanelGroup = styled(Box)({
  height: '100%',
  width: '100%',
});

export const RightPanelShown = styled(Box)({
  transform: 'translateX(0)',
  opacity: 1,
  pointerEvents: 'auto',
  transition: 'transform 0.5s ease, opacity 0.5s ease',
  height: '100%',
  width: '100%',
});

export const RightPanelHidden = styled(Box)({
  transform: 'translateX(100%)',
  opacity: 0,
  pointerEvents: 'none',
  transition: 'transform 0.5s ease, opacity 0.5s ease',
  height: '100%',
  width: '100%',
});

export const ResizeHandle = styled(Box)(({ theme }) => ({
  width: '2px',
  backgroundColor: 'transparent',
  alignItems: 'center',
  justifyItems: 'center',
  position: 'relative',
  cursor: 'col-resize',

  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: '-2px',
    right: '-2px',
    backgroundColor: theme.palette.action.hover,
    transition: 'background-color 0.2s',
  },
  '&:hover::before': {
    backgroundColor: theme.palette.action.selected,
  },
}));
